import {
    GET_BLOCKED_DATE_START,
    GET_BLOCKED_DATE_SUCCESS,
    GET_BLOCKED_DATE_ERROR,
} from '../../constants';
import { getBlockedDatesCalendar as query } from '../../lib/graphql';

export function getBlockedDates(listId, filterDate) {

    return async(dispatch, getState, {client}) => {
        dispatch({
            type: GET_BLOCKED_DATE_START, 
            payload: {
                loading: true
            }
        });

        try {
            const { data } = await client.query({
                query,
                variables: {
                  listId,
                  filterDate
                },
            });

            dispatch({
                type: GET_BLOCKED_DATE_SUCCESS, 
                payload: {
                    loading: false
                }
            });

            return {
                data
            };
        } catch (error) {
            dispatch({
                type: GET_BLOCKED_DATE_ERROR, 
                payload: {
                    error
                }
            });
        }

        return false;
    };
}